import ExIpa from "./Administrator/ExIpaManagement";

export default function ExIpaManagement(props) {
  const { selectedPracticeChange, fetchChangePracticeData } = props;

  return (
    <ExIpa
      selectedPracticeChange={selectedPracticeChange}
      fetchChangePracticeData={fetchChangePracticeData}
    />
  );
}
